import loadable from './loadable';

const routes = [
  {
    path: '/home',
    exact: true,
    childRoutes: [
      {
        path: '/',
        component: loadable(() =>
          import('../pages/home')
        ),
        exact: true,
        title: 'Home',
      },
      {
        path: '/business',
        component: loadable(() =>
          import('../pages/services/business')
        ),
        exact: true,
        title: 'Business Services',
      },
    ],
  },
  // Service Routes - Business Services
  {
    path: '/services/business-registration',
    component: loadable(() =>
      import('../pages/services/business-registration')
    ),
    exact: true,
    title: 'Business Registration',
  },
  {
    path: '/services/vat-filing',
    component: loadable(() =>
      import('../pages/services/vat-filing')
    ),
    exact: true,
    title: 'VAT Filing',
  },
  {
    path: '/services/bookkeeping',
    component: loadable(() =>
      import('../pages/services/bookkeeping')
    ),
    exact: true,
    title: 'Bookkeeping',
  },
  {
    path: '/services/financial-consulting',
    component: loadable(() =>
      import('../pages/services/financial-consulting')
    ),
    exact: true,
    title: 'Financial Consulting',
  },
  // Service Routes - IT & Digital Services
  {
    path: '/services/web-development',
    component: loadable(() =>
      import('../pages/services/web-development')
    ),
    exact: true,
    title: 'Web Development',
  },
  {
    path: '/services/mobile-development',
    component: loadable(() =>
      import('../pages/services/mobile-development')
    ),
    exact: true,
    title: 'Mobile Development',
  },
  {
    path: '/services/software-development',
    component: loadable(() =>
      import('../pages/services/software-development')
    ),
    exact: true,
    title: 'Software Development',
  },
  {
    path: '/services/digital-solutions',
    component: loadable(() =>
      import('../pages/services/digital-solutions')
    ),
    exact: true,
    title: 'Digital Solutions',
  },
  // Service Routes - Infrastructure & Security
  {
    path: '/services/networking',
    component: loadable(() =>
      import('../pages/services/networking')
    ),
    exact: true,
    title: 'Networking',
  },
  {
    path: '/services/bms',
    component: loadable(() =>
      import('../pages/services/bms')
    ),
    exact: true,
    title: 'Building Management System',
  },
  {
    path: '/services/cybersecurity',
    component: loadable(() =>
      import('../pages/services/cybersecurity')
    ),
    exact: true,
    title: 'Cybersecurity',
  },
  {
    path: '/services/it-consulting',
    component: loadable(() =>
      import('../pages/services/it-consulting')
    ),
    exact: true,
    title: 'IT Consulting',
  },
  // Service Routes - AI & Machine Learning
  {
    path: '/services/ai-chatbot',
    component: loadable(() =>
      import('../pages/services/ai-chatbot')
    ),
    exact: true,
    title: 'AI Chatbot Development',
  },
  {
    path: '/services/multi-agent-ai',
    component: loadable(() =>
      import('../pages/services/multi-agent-ai')
    ),
    exact: true,
    title: 'Multi-Agent AI Systems',
  },
  {
    path: '/services/machine-learning',
    component: loadable(() =>
      import('../pages/services/machine-learning')
    ),
    exact: true,
    title: 'Machine Learning Solutions',
  },
  {
    path: '/services/computer-vision',
    component: loadable(() =>
      import('../pages/services/computer-vision')
    ),
    exact: true,
    title: 'Computer Vision & Video Analytics',
  },
  {
    path: '/services/ai-search',
    component: loadable(() =>
      import('../pages/services/ai-search')
    ),
    exact: true,
    title: 'AI Search & Knowledge Systems',
  },
  {
    path: '/services/ai-automation',
    component: loadable(() =>
      import('../pages/services/ai-automation')
    ),
    exact: true,
    title: 'AI Automation & Intelligent Workflows',
  },
  // Product Pages
  {
    path: '/xivohr',
    component: loadable(() =>
      import('../pages/rapidhr')
    ),
    exact: true,
    title: 'XivoHR - Smart Payroll & HR Platform',
  },
  { // legacy path — same page, keeps old links alive
    path: '/rapidhr',
    component: loadable(() =>
      import('../pages/rapidhr')
    ),
    exact: true,
    title: 'XivoHR - Smart Payroll & HR Platform',
  },
  // Main Pages
  {
    path: '/about',
    component: loadable(() =>
        import('../pages/about')
      ),
    exact: true,
    title: 'About Us',
  },
  {
    path: '/contact',
    component: loadable(() =>
        import('../pages/contact')
      ),
    exact: true,
    title: 'Contact',
  },
  {
    path: '/terms',
    component: loadable(() =>
        import('../pages/termsOfServices')
      ),
    exact: true,
    title: 'Terms of Service',
  },
  {
    path: '/privacyPolicy',
    component: loadable(() =>
        import('../pages/privacyPolicy')
      ),
    exact: true,
    title: 'Privacy Policy',
  },
];

export default routes;
